<template>
    <div class="form-inner" style="display: block;"> 

        <div v-if="purchasables.length > 1" class="frm-row">
            <label>Type</label>
            <select class="selectBox" v-model="selectedPurchasable"> 
                <option v-for="(purchasable, idx) in purchasables" :key="purchasable.id || idx" :value="purchasable">
                    {{ purchasable.name }} - £{{ purchasable.price.toFixed(2) }}
                </option>
            </select>
        </div>

        <p class="label">Quantity/Delivery day(s)</p>
       
        <ProductControls 
            :purchasable="selectedPurchasable" 
            :include-day-labels="true"
            :include-clear-button="false"
        />

        <p class="subtotal">Sub total: <span class="js-product-subtotal">£{{ subTotal.toFixed(2) }}</span></p>
    </div>

    <button class="add-to-cart button button--1 button--large" @click="emitAddToBasketEvent" :disabled="subTotal < 0.01">Add to Quote</button>

    <!-- <p class="note">
        Prefer not to create a quote now? Fill in our quick &amp; <a href="/request-a-quote/">simple form</a> and we’ll call you back
    </p> -->

    <Modal :id="selectedPurchasable.name">
        <ModalContentProductAddedToBasket 
            :lineDescription="selectedPurchasable ? selectedPurchasable.name : ''"
            :icon="selectedPurchasable && selectedPurchasable.categoryIcon ? selectedPurchasable.categoryIcon : undefined"
            @close="$emit('close')" 
        />
    </Modal>
</template>

<script setup>
    import { ref, computed } from 'vue';
    import { useBasketStore } from './store';
    import ProductControls from './ProductControls.vue';
    import Modal from './Modal.vue';
    import ModalContentProductAddedToBasket from './ModalContentProductAddedToBasket.vue';

    const basketStore = useBasketStore();

    const props = defineProps({
        purchasables: {
            type: Array,
            required: true
        }
    });

    const selectedPurchasable = ref(props.purchasables[0] ?? null)

    const subTotal = computed(() => {
        const items = basketStore.items.filter(item => item.id === selectedPurchasable.value.id);
        return items.reduce((subTotal, item) => subTotal + basketStore.lineItemSubtotal(item), 0);
    });

    const emitAddToBasketEvent = () => {
        const event = new CustomEvent('open-modal', {
            detail: { id: selectedPurchasable.value.name }
        });
        window.dispatchEvent(event);
    };
</script>

<style scoped>
    select.selectBox {
        border: none;
        padding: 10px;
        appearance: none;
        background-color: #F4F4F4;
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/></svg>');
        background-repeat: no-repeat;
        background-position: right 10px center;
    }

    button[disabled] {
        opacity: 0.4;
        cursor: not-allowed;
    }
</style>